import { useEffect } from "react"
import { UseStepActions } from "@/lib/hooks/useStep"
import SuccessImg from "@/assets/success.png"

type WizardSuccessScreenProps = {
  actions: UseStepActions
  children: React.ReactNode
}

export const WizardSuccessScreen = (props: WizardSuccessScreenProps) => {
  useEffect(() => {
    setTimeout(() => {
      props.actions.goToNextStep()
    }, 2000)
  }, [props])
  return (
    <div className="flex flex-col items-center justify-center gap-5 h-full">
      <div className="max-w-md flex flex-col items-center justify-center gap-8">
        <img src={SuccessImg} alt="Success" width={104} height={104} />
        {props.children}
      </div>
    </div>
  )
}
